export const ACTUALIZAR_SECTORES_REQS = "ACTUALIZAR_SECTORES_REQS";
export const ACTUALIZAR_SECTORES_REQS_LIST = "ACTUALIZAR_SECTORES_REQS_LIST";
export const ACTUALIZAR_SECTORES_REQS_DB = "ACTUALIZAR_SECTORES_REQS_DB";
export const CARGANDO_SECTORES_REQS = "CARGANDO_SECTORES_REQS";
export const ERROR_SECTORES_REQS = "ERROR_SECTORES_REQS";
export const LIMPIAR_ERROR = "LIMPIAR_ERROR";